import { Routes } from '@angular/router';
import { mainrouteGuard } from './auth/mainroute.guard';

export const routes: Routes = [
  // {
  //   path: 'home',
  //   loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
  // },
  {
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full',
  },
  {
    path: 'landing',
    canActivate: [mainrouteGuard],
    loadComponent: () => import('./landing/landing.page').then( m => m.LandingPage)
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage)
  },
  {
    path: 'intro-slides',
    loadComponent: () => import('./pages/intro-slides/intro-slides.page').then( m => m.IntroSlidesPage)
  },
  {
    path: 'registration',
    loadComponent: () => import('./pages/registration/registration.page').then( m => m.RegistrationPage)
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard.page').then((m) => m.DashboardPage),
    children: [
      {
        path: 'home',
        loadComponent: () => import('./pages/dashboard/home/home.page').then((m) => m.HomePage),
      },
      // {
      //   path: 'editor',
      //   loadComponent: () => import('./pages/dashboard/editor/editor.page').then( m => m.EditorPage)
      // },
      {
        path: 'creator-kit',
        loadComponent: () => import('./pages/dashboard/creator-kit/creator-kit.page').then( m => m.CreatorKitPage)
      },
      {
        path: 'social-profile',
        loadComponent: () => import('./pages/dashboard/social-profile/social-profile.page').then( m => m.SocialProfilePage)
      },
      {
        path: 'earnings',
        loadComponent: () => import('./pages/dashboard/earnings/earnings.page').then((m) => m.EarningsPage),
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'notification',
    loadComponent: () => import('./pages/notification/notification.page').then( m => m.NotificationPage)
  },
  {
    path: 'edit-profile',
    loadComponent: () => import('./pages/edit-profile/edit-profile.page').then( m => m.EditProfilePage)
  },
  {
    path: 'whatsapp-support',
    loadComponent: () => import('./pages/whatsapp-support/whatsapp-support.page').then( m => m.WhatsappSupportPage)
  },
  {
    path: 'transaction-details',
    loadComponent: () => import('./pages/transaction-details/transaction-details.page').then( m => m.TransactionDetailsPage)
  },
  {
    path: 'project-details',
    loadComponent: () => import('./pages/project-details/project-details.page').then( m => m.ProjectDetailsPage)
  },
  {
    path: 'notification-detail',
    loadComponent: () => import('./pages/notification-detail/notification-detail.page').then( m => m.NotificationDetailPage)
  },
  {
    path: 'terms-and-policies',
    loadComponent: () => import('./pages/terms-and-policies/terms-and-policies.page').then( m => m.TermsAndPoliciesPage)
  },
  {
    path: 'billing-details',
    loadComponent: () => import('./pages/billing-details/billing-details.page').then( m => m.BillingDetailsPage)
  },
  {
    path: 'creator-tools',
    loadComponent: () => import('./pages/creator-tools/creator-tools.page').then( m => m.CreatorToolsPage)
  },
   {
    path: 'esign/sign/:token',
    loadComponent: () => import('./pages/esign-signing/esign-signing.page').then( m => m.EsignSigningPage)
  },
  {
    path: 'esign/download/:agreementId',
    loadComponent: () => import('./pages/esign-download/esign-download.page').then( m => m.EsignDownloadPage)
  },


  
];
